import { end } from "@popperjs/core";
import { refreshAccessToken } from "./apiClient";
import { API_URL } from "./constant";

// export async function getDailyReportData({orgId,date}) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/daily_report/?date=${date}&org_id=${orgId}`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();
        
//         if(!response.ok){
//             const err = new Error('Failed to fetch daily report data');
//                 err.data = responseData;
//                 err.status = response.status;
//                 throw err;
//         }

//         return responseData;

//     }catch(error){
//         console.log("error while getting daily report data", error?.data || error.message)
//         throw error;
//     }
// }
// Helper function to make the actual API call
async function attemptGetDailyReportData(orgId, date, token) {
    const response = await fetch(`${API_URL}/daily_report/?date=${date}&org_id=${orgId}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    const responseData = await response.json();

    if (!response.ok) {
        const err = new Error('Failed to fetch daily report data');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main function
export async function getDailyReportData({ orgId, date }) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try {
        return await attemptGetDailyReportData(orgId, date, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptGetDailyReportData(orgId, date, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed:", refreshError.message);
                throw refreshError;
            }
        }

        console.error("Error while getting daily report data:", error?.data || error.message);
        throw error;
    }
}

// custom report
// export async function getCustomReport({orgId,startDate,endDate}) {
//     try{
//         const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

//         const response = await fetch(`${API_URL}/custom_report/?org_id=${orgId}&start_date=${startDate}&end_date=${endDate}`,{
//             method:'GET',
//             headers:{
//                 'Authorization': `Bearer ${parsedToken}`,
//             }
//         })

//         const responseData = await response.json();
//         console.log("res api report",responseData)
//         if(!response.ok){
//             const err = new Error('Failed to fetch custom report data');
//                 err.data = responseData;
//                 err.status = response.status;
//                 throw err;
//         }

//         return responseData;
//     }catch(error){
//         console.log("error while getting csutom report data", error?.data || error.message)
//         throw error;
//     }
// }

// Helper function to perform the actual API request
async function attemptGetCustomReport(orgId, startDate, endDate, token) {
    const response = await fetch(`${API_URL}/custom_report/?org_id=${orgId}&start_date=${startDate}&end_date=${endDate}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
        },
    });

    const responseData = await response.json();
    console.log("res api report", responseData);

    if (!response.ok) {
        const err = new Error('Failed to fetch custom report data');
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// Main export function
export async function getCustomReport({ orgId, startDate, endDate }) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));

    try {
        return await attemptGetCustomReport(orgId, startDate, endDate, accessToken);
    } catch (error) {
        if (error.status === 401) {
            try {
                const newAccessToken = await refreshAccessToken();
                return await attemptGetCustomReport(orgId, startDate, endDate, newAccessToken);
            } catch (refreshError) {
                console.error("Token refresh failed:", refreshError.message);
                throw refreshError;
            }
        }

        console.error("Error while getting custom report data:", error?.data || error.message);
        throw error;
    }
}

// generate presigned url for uploading the additonal docs
export async function getPreUrlAddDocs(formData) {
    try{
        console.log("📤 Sending request to get pre-signed URL:", formData);
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/pre_signed_url_additonal_docs/?order_id=${formData.orderId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${parsedToken}`,
            },
            body: JSON.stringify(formData),
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        console.log("✅ Received response from server:", responseData);

        return responseData;

    }catch(error){
        console.log("Error while getting presigned url",error.response?.data || error.message);
        throw error;
    }
}

// upload completion api
export async function uploadCompletionAddDocs(payload){
    try{
        console.log("on api",payload)
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/additionaldocs_completion_api/?order_id=${payload.orderId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${parsedToken}`,
            },
            body: JSON.stringify(payload),
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
    }catch(error){
        console.log("Error while getting presigned url",error.response?.data || error.message);
        throw error;
    }
}

// genrate report
export async function generateReport(orderId) {
    try{
        console.log("api order id",orderId)
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/generate_final_report/?order_id=${orderId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${parsedToken}`,
            },
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
    }catch(error){
        console.log("Error while generating report",error.response?.data || error.message);
        throw error;
    }
}

// genrate report for reviewed product
export async function generateReportReviewed(orderId) {
    try{
        console.log("api order id",orderId)
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/generate_report_reviewed/?order_id=${orderId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${parsedToken}`,
            },
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
    }catch(error){
        console.log("Error while generating report for reviewwd product",error.response?.data || error.message);
        throw error;
    }
}

// download final report
export async function downloadFinalReport(orderId) {
    try{
        const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

        const response = await fetch(`${API_URL}/finalreport_download/?order_id=${orderId}`,{
            method:'GET',
            headers:{
                'Authorization': `Bearer ${parsedToken}`
            }
        })

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
        
    }catch(error){
        console.log("Error while downloading report",error.response?.data || error.message);
        throw error;
    } 
}
// download final zip for basic report
export async function downloadFinalZip(orderId) {
    try{
        const parsedToken = JSON.parse(localStorage.getItem('accessToken'))

        const response = await fetch(`${API_URL}/finalzip_download/?order_id=${orderId}`,{
            method:'GET',
            headers:{
                'Authorization': `Bearer ${parsedToken}`
            }
        })

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
        
    }catch(error){
        console.log("Error while downloading report",error.response?.data || error.message);
        throw error;
    } 
}

// generate and download draft
export async function downloadDraft(orderId) {
    try{
        const accessToken  = localStorage.getItem('accessToken');
        const parsedToken = JSON.parse(accessToken);

        const response = await fetch(`${API_URL}/generate_draft_pdf/?order_id=${orderId}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${parsedToken}`,
            },
            });

        if (!response.ok) {
            throw new Error(`Request failed with status ${response.status}`);
            }

        const responseData = await response.json();
        
        return responseData;
    }catch(error){
        console.log("Error while generating and downloading draft",error.response?.data || error.message);
        throw error;
    }
}

// helper function for get the finance report
async function attemptGetFinanceReport(financeParams,token) {
    
    const params = new URLSearchParams();

    if (financeParams.startDate) params.append('start_date',financeParams.startDate)
    if (financeParams.endDate) params.append('end_date',financeParams.endDate)
    if (financeParams.reportType) params.append('report_type',financeParams.reportType)

    const response = await fetch(`${API_URL}/custom_finance_report/?${params.toString()}`,{
        method:'GET',
        headers:{
            'Authorization': `Bearer ${token}`,
        }
    })

    const responseData = await response.json();

    if(!response.ok){
        const err = new Error("Failed to fetch the custom finance report");
        err.data = responseData;
        err.status = response.status;
        throw err;
    }

    return responseData;
}

// main function to get the finacne repoort
export async function getFinanceReport(financeParams) {
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    try{
        return await attemptGetFinanceReport(financeParams,accessToken)
    }catch(error){
        if (error.status === 401){
            try{
                const newAccessToken = await refreshAccessToken();
                return await attemptGetFinanceReport(financeParams, newAccessToken);
            }catch(refreshError){
                console.log("Token refresh failed",refreshError.message);
                throw refreshError;
            }
        }
        console.log("Error while getting Finacne Report", error?.data || error.message);
        throw error;
    }
}